import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';

import { X_API_KEY } from 'api/ApiConfig';
import axios from 'axios';
import { clearToken, getCookieValue } from 'utils/helpers';
import authTokenSlice from '../api/client-side-slices/AuthTokenSlice';
import designSliceReduces from '../api/client-side-slices/DesignSlice';
import groupsSliceReducer from '../api/client-side-slices/GroupsSlice';

const baseQueryPrime = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_PRIME_COMPLIANCE_API_URL,
  prepareHeaders: async (headers, { getState }) => {
    const state = getState() as RootState;
    const token = getCookieValue('token');
    const auth0Token = state.auth.auth0AccessToken;

    headers.set('X-Api-Key', X_API_KEY);

    if (token) {
      headers.set('user-id', getCookieValue('userName'));
      headers.set('Token', token);
    }

    if (auth0Token) {
      headers.set('Authorization', `Bearer ${auth0Token}`);
    }
    return headers;
  },
});

const MAX_RETRIES = 4;

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  arg,
  api,
  extraOptions
) => {
  const retries = 0;
  let response;

  while (retries < MAX_RETRIES) {
    response = await baseQueryPrime(arg, api, extraOptions);

    const { error } = response;
    const is401 = error && error.status === 401;
    const is400 = error && error.status === 400;

    if (is401) {
      // document.getElementById('btn-login')?.click();
    }

    if (is400) {
      clearToken();
    }

    break;
  }

  return response as any;
};

export const API = () => {
  // const jwt: string | null = getAccessToken()

  const defaultHeaders = {
    'X-Api-Key': X_API_KEY,
    'user-id': 'cristi.oanca@techquarter.io',
  };

  //WIP TODO
  const defaultConfig = {
    baseURL:
      'https://prime-shared-kyc-api-dev.wittysmoke-af9c7a18.australiaeast.azurecontainerapps.io/api',

    headers: defaultHeaders,
  };

  return axios.create(defaultConfig);
};

export const apiPrimeSlice = createApi({
  reducerPath: 'primeApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'Groups',
    'Individuals',
    'EntityRoles',
    'IndividualsById',
    'PrimeSearch',
    'GetEntityById',
  ],
  endpoints: () => ({}),
});

const rootReducer = combineReducers({
  [apiPrimeSlice.reducerPath]: apiPrimeSlice.reducer,
  groups: groupsSliceReducer,
  design: designSliceReduces,
  auth: authTokenSlice,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(apiPrimeSlice.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
